<template>
  <v-app class="copilot">
    <v-app-bar color="var(--theme-identite)" elevation="0" style="z-index: 10 !important" :height="headerHeight">
      <div class="copilot-header d-flex mx-auto" :style="{height: '50px'}">
        <div class="d-flex justify-start align-center ml-5 mr-4" style="flex: 1">
          <v-btn v-if="isGuest" icon color="var(--theme-icone)" @click="retourAuLogin()">
            <icon-home filled style="font-size: 25px" />
          </v-btn>

          <v-btn v-else icon color="var(--theme-icone)" @click="navigateTo('/notifications')">
            <v-badge :content="itemsCount" :model-value="itemsCount > 0" color="var(--theme-erreur)">
              <v-icon>mdi-bell-outline</v-icon>
            </v-badge>
          </v-btn>
        </div>

        <div class="d-flex flex-column align-center header-logo">

          <!-- Logo en haut -->
          <icon-logo_copilot
            filled
            color="white"
            :style="{ fontSize: logoSize }"
            :class="{ logo: !isGuest }"
            @click="onLogoClick"
          />

          <!-- Ligne icone + texte -->
          <div v-if="isGuest && vehiculeStore.getImmatriculation()" class="d-flex flex-row align-center" style="position: fixed;bottom: 5px">

            <icon-vp style="font-size: 20px; color: white; opacity: 0.9;margin-right: 5px" />

            <span

              style="
        color: #2b335b;
        font-size: 12px;
        font-weight: 700;
        letter-spacing: 1px;
        opacity: 0.9;
        text-transform: uppercase;
        line-height: 1;
      "
            >
      {{ formatImmatriculation(vehiculeStore.getImmatriculation()) }}
    </span>

          </div>

        </div>
        <div class="d-flex justify-end align-center ml-4 mr-5" style="flex: 1">
          <template v-if="!isGuest">
            <v-btn v-if="isCredentials" icon color="var(--theme-icone)" @click="navigateTo('/mon-compte')">
              <icon-account filled style="font-size: 25px" />
            </v-btn>

            <v-btn v-else icon color="var(--theme-icone)" @click="logout()">
              <icon-logout_fatec style="font-size: 25px" clickable />
            </v-btn>
          </template>

          <template v-else>
            <div style="display: flex; width: 40px" />
          </template>
        </div>
      </div>
    </v-app-bar>

    <v-main :style="{'padding-bottom': mainPaddingBottom + '!important'}">
      <div :class="{banner: !isOnHomePage() && !isOnCarteAccreditivePage()}" />
      <slot />
    </v-main>

    <v-bottom-navigation v-if="!isGuest" :style="{height: footerHeight}" style="z-index: 10 !important">
      <CopilotMenu />
    </v-bottom-navigation>

    <div v-if="loaderStore.isLoading()" class="progress-layout d-flex align-center justify-center">
      <v-progress-circular color="var(--theme-icone)" indeterminate />
    </div>
  </v-app>
</template>

<script lang="ts" setup>
import CopilotMenu from '~/components/ui/menu/menu.vue';
import {useDisplay} from 'vuetify';

const {name} = useDisplay();
const route = useRoute();
const authenticationStore = useAuthentificationStore();
const loaderStore = useLoaderStore();
const vehiculeStore = useVehiculeStore();
const notificationStore = useNotificationStore();

// --- DETECTION DU MODE ---
const isGuest = computed(() => authenticationStore.getModeConnexion() === 'guest');
const isCredentials = computed(() => authenticationStore.getModeConnexion() === 'credentials');

// --- STYLES DYNAMIQUES ---
const footerHeight = computed(() => (name.value === 'xs' ? '60px' : '80px'));
const headerHeight = computed(() => {
  if (isGuest.value) {
    // Taille agrandie pour le mode Guest (Logo + Texte)
    return name.value === 'xs' ? 90 : 100;
  } else {
    // Taille normale pour le mode connecté
    return name.value === 'xs' ? 56 : 60;
  }
});
const logoSize = computed(() => (name.value === 'xs' ? '110px' : '130px'));

const mainPaddingBottom = computed(() => {
  if (isGuest.value) return '0px';
  return footerHeight.value;
});

// --- ACTIONS ---
const onLogoClick = () => {
  if (!isGuest.value) navigateTo('/');
};

const isOnHomePage = () => route.path === '/';
const isOnCarteAccreditivePage = () => route.path === '/carte-accreditive'

const logout = () => {
  authenticationStore.logout();
};

const itemsCount = computed(() => notificationStore.getNotificationsFiltree('nonLues')?.length);

onMounted(async () => {
  if (!isGuest.value) {
    const {requestToken} = await useFirebaseMessaging();
    const notificationsToken = await requestToken();
    if (notificationsToken) {
      vehiculeStore.abonnementNotifications(notificationsToken);
    }
  }
});

const retourAuLogin = () => {
  authenticationStore.logout();
  navigateTo('/login');
};
</script>

<style scoped>
.copilot {
  background: none !important;
}
.copilot-header {
  max-width: 700px;
  width: 100%;
  display: flex;
}
.header-logo {
  width: 100%;
}
.logo:hover {
  cursor: pointer;
}
.banner {
  position: absolute;
  height: 150px;
  width: 100%;
  background-color: var(--theme-identite-2);
  z-index: -1;
}
</style>

<style>
.grecaptcha-badge {
  visibility: hidden;
}
</style>
